module.exports = __webpack_public_path__ + "img/9.91daf53b.jpg";